import { TypeColumnHalf } from '@/core/generated-types/TypeTwoColumnHalf';
import TwoColumnHalf from './TwoColumnHalf';

export interface TwoColumnProps {
  halfs: TypeColumnHalf[];
}

const TwoColumn: React.FC<TwoColumnProps> = ({ halfs }) => {
  return (
    <div className="w-full h-auto flex flex-col lg:flex-row justify-center items-center bg-off-white py-10 lg:py-20">
      {halfs.map((half, index) => {
        return (
          <TwoColumnHalf
            {...half}
            isSecondHalf={index % 2 !== 0}
            key={half.sys.id}
          />
        );
      })}
    </div>
  );
};

export default TwoColumn;
